export default "<app-monthly-charges-tab [reportSection]=\"reportSection\"></app-monthly-charges-tab>\r\n";